import faqDataEs from "../faq/FAQDataEs";

export const Spanish = {
  translation: {
    brandInfo: {
      botName: {
        lifesafer: "Lili",
        monitechiid: "Molly",
        guardianinterlock: "Gabby",
        quickstartaz: "Kelly",
      },
      brandName: {
        lifesafer: "LifeSafer",
        monitechiid: "Monitech",
        guardianinterlock: "Guardian Interlock",
        quickstartaz: "QuickStart",
      },
      brandPhone: {
        lifesafer: "(855) 221-0171", //special phone number for LS installations
        monitechiid: "(800) 521-4246",
        guardianinterlock: "(800) 499-0994",
        quickstartaz: "(888) 717-8278",
      },
      brandPhoneHref: {
        lifesafer: "tel:+1-855-221-0171",
        monitechiid: "tel:+1-800-521-4246",
        guardianinterlock: "tel:+1-800-499-0994",
        quickstartaz: "tel:+1-888-717-8278",
      },
    },
    policies: {
      termsofUseLabel: "Condiciones",
      privacyLabel: "Privacidad",
      cookiesLabel: "Galletas",
      qualityLabel: "Calidad",
      copyrightLabel: "Derechos de autor",
      callMonitech:
        "Desafortunadamente no estamos en este estado, pero buenas noticias, ¡nuestro socio Monitech brinda servicio en este estado! No dude en ponerse en contacto con Monitech en (800) 521-4246.",
      countyQuestionable:
        "Para este condado, necesitaremos que se comunique con nosotros para que podamos ayudarlo con la inscripción, (800) 634-3077.",
    },
    faqs: {
      header: "Preguntas Frecuentes",
      button: "Ver Preguntas Frecuentes",
      tipOfTheDay: "Consejo del Día",
      faqData: faqDataEs,
      faqDataAU: faqDataEs,
    },
    carousel: {
      name1: "Citas",
      description1:
        "Vea, programe, cambie o cancele sus citas de servicio de manera conveniente y rápida.",
      name2: "Pagos",
      description2:
        "Vea, configure o cambie su método de pago preferido de manera fácil y segura, lo que le permite tener el control de su cuenta.",
      name3: "Recursos del Dispositivo",
      description3:
        "Revise, mire y obtenga información importante sobre su dispositivo para que pueda comprender su viaje con LifeSafer.",
    },
    registration: {
      sectionTitle: "Registro",
      personalInformationStep: "Informacion personal",
      addressStep: "Dirección",
      passwordStep: "Contraseña",
      verify: "Verificar",
      continue: "Continuar",
      createAccount: "Crear una cuenta",
      backToSignIn: "Volver a Iniciar Sesión",
      firstName: "Primer Nombre Legal",
      firstNameRequired: "Se requiere el primer nombre.",
      firstNameLengthError: "El nombre debe tener dos letras o más.",
      lastName: "Apellido Legal",
      lastNameRequired: "Se requiere apellido.",
      lastNameLengthError: "El apellido debe tener dos letras o más.",
      cityRequired: "Se requiere ciudad.",
      cityMinLength: "La longitud mínima es 2.",
      cityInvalid: "La ciudad no es válida.",
      emailAddress: "Dirección de Correo Electrónico",
      emailRequied: "Correo electronico es requerido.",
      emailValid: "Dirección de correo electrónico inválida.",
      phoneType: "Tipo de Telefono",
      cellPhone: "Teléfono Móvil",
      homePhone: "Teléfono de Casa",
      phoneNumber: "Número de Teléfono",
      homePhoneRequired: "Se requiere el número de teléfono.",
      phoneValid: "Dirección de correo electrónico inválida.",
      verifyPersonalInformation: "Verificar",
      homeAddressLine1: "Dirección Línea 1",
      poHomeAddressPlaceHolder: "Ingrese su apartado postal",
      addressRequired: "Se requiere la dirección de casa.",
      addressDirections:
        "Deberá seleccionar una dirección de la función de autocompletar. Si no encuentra su dirección, ingrese su ciudad y estado y seleccione.",
      homeAddressLine2: "Dirección Línea 2",
      homeAddressPlaceHolder: "Ingrese la dirección de su casa.",
      homeCityCountyState: "Ciudad, Condado, Estado",
      homeCityCountyStatePlaceHolder: "¡Esto se completará por ti!",
      homeCity: "Ciudad", // not required
      homeCounty: "Condado", // not required
      homeState: "Estado", // not required
      stateRequired:
        "Se requiere estado. Ingrese una dirección válida o seleccione una de la lista desplegable Línea de dirección 1.",
      stateValid: "El estado debe ser válido.", // not required
      homeZip: "Código Postal",
      zipRequired: "Se requiere el código postal.",
      zipValid: "Un código postal válido debe tener 5 dígitos de longitud.",
      continueFromAddress: "Continuar",
      password: "Contraseña",
      passwordRequired: "Se requiere contraseña.",
      passwordPattern:
        "La contraseña debe tener entre 8 y 24 caracteres, contener al menos 1 letra mayúscula, 1 letra minúscula, 1 número y 1 carácter especial.",
      confirmPassword: "Confirmar Contraseña",
      confirmPasswordMatch: "Las contraseñas deben coincidir.",
      confirmPasswordRequired: "Se requiere confirmación de contraseña.",
      GoogleText1: "Este sitio está protegido por reCAPTCHA y se aplican la ",
      GoogleText2: " y los ",
      GoogleText3: " de Google.",
      GoogleLink1: "Política de Privacidad",
      GoogleLink2: "Términos de Servicio",
      emailInUse: "El correo electrónico ya está en uso.",
      emailInUseInstructions:
        "Ingrese un correo electrónico diferente o restablezca su contraseña.",
      here: "Aquí",
      phoneNumberInUse:
        "Número de teléfono ya en uso con otro correo electrónico.",
      continueToLogin: "Para continuar usando ",
      returnToLogin: "Volver a iniciar sesión",
      verifyEmail:
        "Para usar el correo electrónico ingresado por favor verifique ",
      apiErrorTitle: "Error al contactar con el servidor.",
      apiError:
        "Ocurrió un error al intentar verificar su información. Inténtalo de nuevo.",
      registrationComplete: [
        "¡Registro completado con éxito!",
        "Se iniciará sesión automáticamente.",
        "Si por algún motivo no lo está, vuelva a la página de inicio de sesión e inicie sesión.",
      ],
      verificationCode: "Código de verificación",
      verificationCodeTitle: "Verificar número de teléfono",
      verificationCodeDescription:
        "El correo electrónico ingresado ya existe en nuestro sistema con un número de teléfono diferente. Para continuar usando el correo electrónico ingresado, verifique su teléfono con el código que le enviamos por mensaje de texto.",
      submitVerificationCode: "Ingrese el código",
      verificationCodeRequired: "Código de verificación requerido.",
      verificationCodeInvalid: "Código de verificación no válido",
      verificationCodeIncorrect:
        "El código de verificación era incorrecto. Verifique dos veces e ingrese nuevamente.",
      verificationCodeExpired: "Código de verificación expirado.",
      dateOfBirth: "Fecha de nacimiento",
      dateOfBirthRequired: "Fecha de nacimiento requerida.",
      dateOfBirthInvalid: "Se requiere una fecha de nacimiento válida.",
      resetPassword: "Restablecer la contraseña",
      changeEmail: "Cambiar e-mail",
      contactUs: "Contacta con nosotros",
      contactUsMessage:
        "No tenemos un teléfono celular registrado para usted. Por favor llámenos al (800) 634-3077",
      emailUpdateError: "Error al actualizar el correo electrónico.",
      city: "Ciudad",
      honeyPotError: "Algo salió mal, por favor contáctenos para ayudarle.",
    },
    account: {
      headerSlogan: "Estamos comprometidos con su éxito",
      email: "Dirección de Correo Electrónico",
      emailRequired: "Correo electronico es requerido.",
      emailValid: "Dirección de correo electrónico inválida.",
      password: "Contraseña",
      passwordRequired: "Se requiere contraseña.",
      passwordForgot: "¿Ha olvidado su contraseña?",
      signInButton: "Iniciar Sesión",
      resetPasswordMessage:
        "Una vez que haga clic en el botón Restablecer contraseña, se le enviará un enlace para restablecer la contraseña a esta dirección de correo electrónico. Vaya a su correo electrónico para completar el paso final del restablecimiento.",
      resetPasswordButton: "Restablecer la Contraseña",
      backToSignInButton: "Volver a Iniciar Sesión",
      resetPasswordSent:
        "Se ha enviado un enlace para restablecer la contraseña a esta dirección de correo electrónico. Vaya a su correo electrónico para completar el paso final del restablecimiento.",
      resetPasswordSuccess:
        "Consulte su correo electrónico para obtener instrucciones para restablecer la contraseña.",
      resetPasswordError:
        "El reinicio falló, este correo electrónico no está registrado o no está confirmado con LifeSafer.",
      passwordPattern:
        "La contraseña debe tener entre 8 y 24 caracteres, contener al menos 1 letra mayúscula, 1 letra minúscula, 1 número y 1 carácter especial.",
      confirmPassword: "Confirmar Contraseña",
      confirmPasswordRequired: "Se requiere confirmación de contraseña.",
      confirmPasswordValid: "Las contraseñas deben coincidir.",
      tokenFailedPart1:
        "La validación del token falló, si el token ha caducado, puede obtener uno nuevo en la página de ",
      tokenFailedPart2: "contraseña olvidada",
      phoneEmail: "Número de Teléfono Celular o Dirección de Correo Electrónico",
      phoneEmailRequired: "Se requiere número de teléfono celular o dirección de correo electrónico",
      phoneValid: "Número de teléfono inválido",
      tokenFailedPart3: ".",
      tokenValidation: "Validación de Token...",
      verifyHeader: "Verificar Correo Electrónico",
      verificationFailedPart1:
        "La verificación falló, también puede verificar su cuenta usando la página de ",
      verificationSuccess: "Verificación exitosa, ahora puede iniciar sesión.",
      tokenVerification: "Verificando...",
      registrationSuccess:
        "Registro exitoso, por favor revise su correo electrónico para ver las instrucciones de verificación.",
      registrationFail:
        "El registro falló, este correo electrónico ya está registrado.",
      passwordResetSuccess:
        "Restablecimiento de contraseña exitoso, ahora puede iniciar sesión.",
    },
    navigation: {
      dashboard: "Panel",
      appointments: "Citas",
      payments: "Pagos",
      documents: "Documentos",
      resources: "Recursos",
      help: "Ayuda",
      logOut: "Cerrar Sesión",
      language: "Idioma",
      notifications: "Notificaciones",
      profile: "Perfil",
    },
    buttons: {
      updateButton: "Actualizar",
      nextButton: "Próxima",
      deleteButton: "Borrar",
      createButton: "Crear",
      cancelButton: "Cancelar",
      closeButton: "Cerca",
      saveButton: "Ahorrar",
    },
    toasts: {
      updateComplete: "Actualizacion completa.",
      updateFailed: "Actualización fallida.",
      deleteNotification: "Notificación eliminada.",
      messageDeleted: "Mensaje borrado",
      messageUpdated: "Mensaje actualizado",
      messageCreated: "Mensaje creado.",
      error: "¡Se ha producido un error!",
      uploadComplete: "Subida finalizada.",
      uploadFailed: "Subida fallida.",
      saving: "Guardando.",
    },
    home: {
      upcomingAppointments: "Próximas Citas",
      noAppointments: "Actualmente no tiene citas próximas.",
      scheduleButton: "Calendario",
      upcomingPayments: "Próximos Pagos",
      paymentPastDue: "Pago Vencido",
      paymentAttentionNeeded: "Atención necesaria",
      noPayments: "You currently don't have any upcoming payments.",
      paymentsSignUp:
        "Actualmente no estás registrado para pagos automáticos. Ahorre tiempo e inscríbase hoy.",
      signUpButton: "¡Regístrese ahora!",
      noNotifications: "Actualmente no tienes ninguna notificación.",
      deviceInfo: "Dispositivo",
      noDevice: "Actualmente no tiene un dispositivo LifeSafer.",
      IID: "Bloqueo de Encendido",
      PAM: "Monitor de Alcohol Portátil",
      serviceLocation: "Ubicación del Servicio:",
      directions: "Direcciones",
      saveTime: "Ahorre tiempo, inscríbase en el pago automático:",
      paymentMethod: "Método de Pago:",
      autoPay: "Pago automático:",
      autoPayProcessDate:
        "Tu pago automático se procesará en la fecha indicada arriba.",
      endingIn: "Últimos 4:",
      paymentQuote:
        "El monto citado anteriormente es una estimación de su saldo vencido y una compra de 14 días adicionales.",
      FC100UserGuide:
        "https://www.lifesafer.com/wp-content/uploads/2020/10/223952-CH_FC100_ESP_updated2.pdf",
      L250UserGuide:
        "https://www.lifesafer.com/wp-content/uploads/2018/02/l250-esp.pdf",
      PAMUserGuide:
        "https://s33035.pcdn.co/wp-content/uploads/2020/02/LS681.PAM-English-User-Guide.pdf",
      userGuide: "Guía del Usuario",
      tipsAndCare: "Consejos y cuidados",
      training: "Entrenamiento",
      troubleshooting: "Solución de Problemas",
      yesButton: "Sí",
      frequentlyAskedQuestions: "Preguntas Frecuentes",
    },
    notifications: {
      typeHeader: "Tipo",
      messageHeader: "Aviso",
      dateHeader: "Fecha",
      deleteButton: "Borrar",
      deleteToast: "Notificación eliminada.",
      updateFailed: "Actualización fallida.",
      messageTooltip: "No leído",
      deleteTooltip: "Eliminar notificación",
      dashboardButton: "Panel",
    },
    profile: {
      personal: "Personal",
      personalFull: "Información Personal",
      information: "Información",
      state: "Estado",
      stateFull: "Información del Estado",
      court: "Corte",
      courtFull: "Información de la Corte",
      vehicle: "Vehículo",
      vehicleFull: "Información del Vehículo",
      name: "Nombre",
      email: "Correo Electrónico",
      password: "Contraseña",
      lastChanged: "Último Cambio: ",
      phone: "Teléfono",
      cell: "Móvil",
      home: "Casa",
      emergencyContact: "Contacto de Emergencia",
      preferences: "Preferencias",
      contactByText: "Contacto por Mensaje de Texto",
      contactByEmail: "Contacto por Correo Electrónico",
      defaultLanguage: "Idioma",
      update: "Actualizar",
      firstName: "Primer Nombre Legal",
      lastName: "Apellido Legal",
      firstNameRequired: "Se requiere el primer nombre.",
      lastNameRequired: "Se requiere apellido.",
      currentEmail: "Correo electrónico actual",
      newEmail: "Nuevo Correo Electrónico",
      confirmEmail: "Confirme Nuevo Correo Electrónico",
      emailWarning:
        "* Tenga en cuenta que al actualizar su correo electrónico, esto cambiará su correo electrónico de inicio de sesión",
      newEmailRequired: "Se requiere un nuevo correo electrónico.",
      emailInvalid: "Dirección de correo electrónico inválida.",
      confirmEmailRequired:
        "Confirme que se requiere un nuevo correo electrónico.",
      matchEmail: "Las direcciones de correo electrónico deben coincidir.",
      confirmPassword: "Confirmar Contraseña",
      passwordWarning:
        "* Su contraseña debe tener un mínimo de 8 caracteres y contener al menos 1 letra mayúscula, 1 letra minúscula, 1 número y 1 carácter especial.",
      textMessageWarning:
        "¡Deshabilitar los mensajes de texto hará que sea más difícil iniciar sesión o restablecer su contraseña en su sitio Mi cuenta!",
      passwordRequired: "Se requiere contraseña.",
      passwordValid:
        "La contraseña debe tener entre 8 y 24 caracteres, contener al menos 1 letra mayúscula, 1 letra minúscula, 1 número y 1 carácter especial.",
      confirmPasswordRequired: "Se requiere confirmación de contraseña.",
      matchPassword: "La contraseña debe coincidir.",
      cellPhone: "Teléfono Móvil",
      homePhone: "Teléfono de Casa",
      homePhoneRequired: "Se requiere teléfono de casa.",
      phoneValid: "Se requiere un número de teléfono válido.",
      eContactFirstName: "Nombre del Contacto de Emergencia",
      eContactLastName: "Apellido del Contacto de Emergencia",
      eContactPhone: "Teléfono de Contacto de Emergencia",
      eContactFirstNameReq: "Se requiere el nombre del contacto de emergencia.",
      eContactLastNameReq:
        "Se requiere el apellido del contacto de emergencia.",
      eContactPhoneReq: "Se requiere el número de teléfono.",
      eContactPhoneValid: "Se requiere un número de teléfono válido.",
      mayWeText: "¿Podemos comunicarnos con usted por mensaje de texto?",
      mayWeEmail: "¿Podemos comunicarnos con usted por correo electrónico?",
      languageSelect: "Selecciona un Idioma",
      languagePrefReq: "Se requiere preferencia de idioma.",
      dob: "Cumpleaños",
      address: "Dirección",
      stateID: "ID del Estado",
      dobLabel: "Fecha de Nacimiento",
      addrLine1: "Dirección Línea 1",
      addrLine2: "Dirección Línea 2",
      city: "Ciudad",
      country: "País",
      stateSelect: "Selecciona un Estado",
      zip: "Código Postal",
      addrLine1Required: "Se requiere la dirección de casa.",
      cityRequired: "Se requiere ciudad.",
      stateRequired: "Se requiere el estado.",
      zipRequired: "Se requiere el código postal.",
      zipValid: "Un código postal válido debe tener 5 dígitos de longitud.",
      zipInvalid: "El código postal no es válido",
      IDNumber: "Número de Identificación",
      expDate: "Fecha de Vencimiento",
      expDateRequired: "Se requiere fecha de caducidad.",
      IDNumberRequired: "Se requiere un número de identificación.",
      conviction: "Convicción",
      courtContact: "Contacto de la Corte",
      contactEmail: "Correo Electrónico de Contacto",
      LSDevice: "Dispositivo LifeSafer",
      VIN: "VIN",
      licensePlate: "Matrícula",
      pushStart: "Encendido por Botón",
      remoteStart: "Inicio Remoto",
      currentVIN: "VIN Actual",
      newVIN: "Nuevo VIN",
      confirmVIN: "Confirmar VIN",
      VINMessagePart1: "* VIN - Número de Identificación del Vehículo",
      VINMessagePart2:
        "Un código de identidad de 16 o 17 caracteres compuesto por números y letras que identifica su vehículo.",
      VINRequired: "Se requiere VIN.",
      VINValid: "El VIN debe tener 16 o 17 caracteres de longitud.",
      VINConfirmRequired: "Se requiere confirmación de VIN.",
      VINMatch: "Los VIN deben coincidir.",
      vehicleConfirm: "Confirmación del Vehículo",
      year: "Año: ",
      make: "\nMarca: ",
      model: "\nModelo: ",
      VINError: "La verificación de VIN no es válida. Vuelva a intentarlo.",
      currentLP: "Matrícula Actual: ",
      newLP: "Nuevo Número de Matrícula",
      confirmLP: "Confirmar el Número de Matrícula",
      licensePlateRequired: "Se requiere placa de matrícula",
      confirmLPRequired: "Confirme que se requiere la placa de matrícula.",
      licensePlateMatch: "Los números de matrícula deben coincidir.",
      havePushStart: "¿Este vehículo tiene encendido por empuje?",
      pushStartMessage:
        "El encendido por empuje es un botón sin llave que le permite arrancar su vehículo mientras está dentro del vehículo, por lo general con el pedal del freno presionado.",
      haveRemoteStart: "¿Este vehículo tiene encendido de arranque remoto?",
      remoteStartMessage:
        "El encendido de arranque remoto es un llavero que tiene un botón que le permite encender su vehículo mientras está fuera del vehículo presionando este llavero.",
      updateComplete: "Actualizacion completa.",
      passwordUpdateSuccess: "Actualización de contraseña exitosa.",
      updatePreferencesError: "No se pueden actualizar las preferencias.",
      contactUs:
        "Hay un problema al actualizar su perfil, contáctenos para que podamos ayudarlo.",
      lName: "Apellido",
    },
    appointments: {
      appointment: "Cita",
      scheduleApptButton: "Programar una Cita",
      scheduleInstButton: "Programar instalación",
      nextDayMessage:
        "Actualmente no estamos programando citas en línea para el mismo día o para el día siguiente. Si necesita una cita el mismo día o al día siguiente, ",
      within24Message:
        "Está intentando cambiar una cita dentro de las 24 horas posteriores a la cita, comuníquese con nosotros para que podamos ayudarlo con esta solicitud.",
      within4Message:
        "Está intentando cambiar una cita dentro de las 4 horas posteriores a la cita, comuníquese con nosotros para que podamos ayudarlo con esta solicitud.",
      undefinedApptMessage:
        "Esta cita no se puede reprogramar desde este portal, por favor contáctenos para que podamos ayudarlo con esta solicitud.",
      cantChangeMessage:
        "Está intentando cambiar una cita de instalación, comuníquese con nosotros para que podamos ayudarlo con esta solicitud.",
      reschedule: "Reprogramar",
      cancel: "Cancelar",
      rescheduleMessage:
        "Mantenga el cumplimiento, reprograme su cita en línea hoy.",
      contactUsMessage:
        "Deje que nuestro equipo de soporte capacitado lo ayude con esta cita.",
      cancelMessagePart1: "Cancela tu cita programada.",
      cancelMessagePart2:
        "Cancelar citas puede ponerlo en riesgo de una infracción de cumplimiento.",
      keep: "Guardar",
      cancelWarning:
        "Tenga en cuenta que la cancelación dará a conocer esta fecha y hora para esta ubicación. No podemos garantizar que esta fecha y hora estén disponibles en esta ubicación si desea reprogramar.",
      deviceSelect: "Seleccione un Dispositivo",
      lockoutAlertPart1:
        "Atención: tenga en cuenta que es su responsabilidad recibir servicio antes de la fecha de bloqueo, su fecha de bloqueo actual es",
      lockoutAlertPart2:
        "Si tiene alguna pregunta, comuníquese con LifeSafer al",
      apptLocContactUsMessage:
        "Comuníquese con nosotros directamente para programar una cita en este lugar.",
      apptDeinstallContactUsMessage:
        "Comuníquese con nosotros directamente para programar una Cita de desinstalación y asegurarse de que se sigan todas las regulaciones estatales.",
      deinstall: "Desinstalar",
      personalInfo: "Informacion personal",
      location: "Ubicación",
      service: "Servicio",
      enterTextBox: "Ingrese el código postal o ciudad, estado",
      search: "Buscar...",
      noLocations: "No hay ubicaciones en el área seleccionada.",
      searchResults: "Resultados de la Búsqueda",
      select: "Seleccione",
      pastDueService:
        "Su servicio está vencido, ¡consigamos ayuda de nuestro soporte experto 24 horas al día, 7 días a la semana!",
      almostPastDueService:
        "Necesita un servicio inmediato, ¡consigamos la asistencia de nuestro soporte experto 24 horas al día, 7 días a la semana!",
      selectedLocation: "Ubicación Seleccionada",
      selectedService: "Servicio Seleccionado",
      noAppointmentsAvail:
        "Actualmente no hay citas disponibles para esta ubicación.",
      noTimesAvail:
        "No hay horarios disponibles para citas en esta ubicación para esta fecha.",
      backToCalendar: "Volver al Calendario",
      aptSchedPart1: "Ha seleccionado ",
      aptSchedPart2: " reprogramar \n una ",
      aptSchedPart2Alt: "hacer una \n nueva ",
      aptSchedPart3: "cita el: \n",
      aptSchedPart4: " a las ",
      aptSchedPart5: "\n para un Servicio de ",
      aptSchedPart6: "\n ",
      aptSchedPart7: "en la siguiente ubicación: \n",
      originalAppt: "Fecha/Hora Original de la Cita",
      date: "Fecha",
      time: "Tiempo",
      cancelSuccess: "Cita cancelada.",
      cancelFail: "Falló la cancelación.",
      apptSaveSuccess: "Cita guardada.",
      apptUpdateSuccess: "Cita actualizada.",
      mapInfo: "Información del Mapa",
      sameDayLoc: "Ubicación el mismo día",
      standardLoc: "Ubicación estándar",
      installStep1: "¿Cuál es el código de inscripción que se le proporciona?",
      installCodeInputLabel: "Código de Inscripción",
      installCodeInputRequired: "Se requiere el código de inscripción.",
      installCodeInputInvalid: "Código de inscripción no válido.",
      installNoCode: "¿No tienes un código de inscripción? Haga clic ",
      installStateLabel: "Estado",
      installStatePlaceholder: "Selecciona un Estado",
      stateRequired: "Se requiere el estado.",
      cantFindState:
        "¿No encuentra el estado que busca? Comuníquese con nuestro equipo de soporte para que se comunique con uno de nuestros socios que presta servicios en su estado. Llame o haga clic en el botón de abajo.",
      installCountyLabel: "Condado",
      installCountyPlaceholder: "Seleccione un Condado",
      countyRequired: "Se requiere el condado.",
      installNotAvailable: [
        "Desafortunadamente, ",
        " no presta servicios en este estado en este momento. No dude en llamarnos si tiene preguntas, ",
        "(800) 634-3077.",
      ],
      installStep2: [
        "¿Por favor, ingrese en qué estado lo condenaron o se ofrecieron como voluntario para tener un dispositivo ",
        ".",
      ],
      IIDButtonLabel: "Dispositivo de Bloqueo de Encendido",
      PAMButtonLabel: "Monitor de Alcohol Portátil",
      installStep3Part1: "¿Qué tipo de dispositivo necesitas? Haga clic ",
      installStep3Part2:
        " para obtener información rápida si no sabe qué dispositivo necesita.",
      installStep3ButtonLabel: "aquí",
      devicePopupTitle: " Información del Dispositivo",
      devicePopupButtonLabel: "Cerca",
      startedEnrollmentPopupTitle: "Started Enrollment Previously?",
      startedEnrollmentBody:
        "¡No se preocupe, lo tenemos cubierto! ¡Simplemente ingrese su dirección de correo electrónico que usó anteriormente y su número de teléfono y lo llevaremos de regreso a donde estaba en la inscripción!",
      IDStateLabel: "Estado emisor de la identificación",
      IDNumberLabel: "Número de identificación",
      IDInfoTitle: "Información de identificación estatal",
      vehInfoTitle: "Información del vehículo",
      multiVehicleNew: "Vehículo Nuevo",
      vehYearLabel: "Año del Vehículo",
      vehYearPlaceholder: "Seleccione un año",
      vehYearRequired: "Se requiere el año del vehículo.",
      vehMakeLabel: "Marca del Vehículo",
      vehMakePlaceholder: "Seleccione una Marca",
      vehMakeRequired: "Se requiere la marca del vehículo.",
      vehModelLabel: "Modelo de Vehículo",
      vehModelPlaceholder: "Seleccione un modelo",
      vehModelRequired: "Se requiere modelo de vehículo.",
      VINYearLabel: "Año: ",
      VINMakeLabel: "\nMarca: ",
      VINModelLabel: "\nModelo: ",
      licPlateIssue:
        "Hmm, algo salió mal en mi cableado, ingrese el número de placa de su vehículo y el estado de emisión una vez más. Si no lo tiene, haga clic en el botón rojo para omitir.",
      licPlateLabel: "Numero de Licencia",
      licPlateRequired: "Se requiere el número de placa.",
      vehSaveError: "Vehículo no guardado",
      adminButtonLabel: "Administrativa",
      courtButtonLabel: "Mandato Judicial",
      voluntaryButtonLabel: "Voluntaria",
      preTrialButtonLabel: "Antes del Juicio",
      probationButtonLabel: "Libertad Condicional",
      VINInfoLinkPart1: "Haga clic ",
      VINInfoLinkPart2:
        " para obtener información rápida sobre el número de identificación de su vehículo (VIN).",
      VINInfoLink: "aquí",
      ProgTypeInfoLinkPart2:
        " para obtener información rápida sobre los Tipos de Programas.",
      programTypeIssue:
        "Hmm, algo salió mal en mi cableado, ¡selecciona tu tipo de programa una vez más por mí!",
      ProgTypeInfoTitle: "Tipos de Programas",
      AdminDescription:
        "Este tipo de programa generalmente lo asigna la Administración de Vehículos Motorizados.",
      CourtOrderDescription:
        "El tribunal ha ordenado que le instalen un dispositivo.",
      VoluntaryDescription:
        "Ofrecerse como voluntario para instalar un dispositivo es una excelente manera de protegerse a sí mismo y a los demás.",
      PreTrialDescription:
        "Este tipo de programa generalmente significa que es posible que aún no haya ido a la corte o haya sido sentenciado.",
      ProbationDescription:
        "El tribunal ha ordenado que se le instale un dispositivo porque ha sido condenado en 1 o más casos anteriores.",
      closePopUp: "Cerca",
      lossProtectionQuestion:
        "¿Le gustaría incluir un plan de protección contra pérdidas para su dispositivo?",
      lossProtectionInfoLinkPart2:
        " para obtener información rápida sobre el Plan de protección contra pérdidas.",
      lossProtectionInfoTitle: "Plan de protección contra pérdidas",
      lossProtectionInfoPart1: [
        "Los dispositivos de monitoreo ",
        " no son baratos y no nos gustaría verlo atascado con la factura si algo sucediera. El Plan de protección contra pérdidas ",
        " evita este riesgo necesario de no tener protección contra accidentes ocasionales, ¡le recomendamos encarecidamente que proteja su dispositivo!",
      ],
      lossProtection: "Protección contra pérdidas",
      noProtection: "Sin protección",
      lossProtectionIssue:
        "Hmm, algo salió mal en mi cableado, ¡selecciona tu protección contra pérdidas una vez más por mí!",
    },
    payments: {
      accountInfo: "Información de la Cuenta",
      makePayment: "Realizar un Pago",
      paymentMethods: "Métodos de Pago",
      accountBalance: "Saldo de la Cuenta",
      accountHistory: "Historial de Cuenta",
      makePaymentButton: "Realizar un Pago",
      acctBalMessage1: "Espere por favor",
      acctBalMessage2: "Saldo disponible en breve...",
      dateHeader: "Fecha",
      descHeader: "Descripción",
      amountHeader: "Monto",
      invoiceHeader: "Factura",
      balanceHeader: "Saldo",
      transHistory: "Historial de Transacciones",
      newCardButton: "Agregar Nueva Tarjeta",
      noAutoPayMessage:
        "Actualmente, su cuenta no está configurada para pago automático.",
      cardRejectedMessage: "Esta tarjeta ha sido rechazada. Edite o elimine.",
      autoPay: "Pago Automático",
      autoPayMessage:
        "Al marcar esta casilla, nos autoriza a realizar el cargo en esta tarjeta de conformidad con los Términos y condiciones de su Acuerdo de servicio del programa.",
      billingCycleLabel: "Ciclo de Facturación",
      weekly: "Semanal",
      biweekly: "Quincenal",
      monthly: "Mensual",
      editButton: "Editar",
      deleteButton: "Borrar",
      deleteMessage: "¿Está seguro de que desea eliminar esta forma de pago?",
      acceptedPayMethods: "Métodos de Pago Aceptados",
      paymentMethod: "Método de Pago",
      redoMessage: "Deberá volver a validar la información de la tarjeta.",
      zipCode: "Código Postal",
      cardNumber: "Número de Tarjeta",
      expDate: "Caducidad",
      autoPaySignUpMessage:
        "Al enviar la información de su tarjeta de crédito o débito en esta página y marcar esta casilla, nos autoriza a realizar el cargo en esta tarjeta de conformidad con los Términos y condiciones de su Acuerdo de servicio del programa.",
      autoPayEnroll: "Inscríbase en Pago Automático",
      zipCodeError: "Código postal no válido, corríjalo.",
      cardNumberError: "Número de tarjeta no válido, vuelva a intentarlo.",
      cvv2Error: "CVV2 no válido, por favor corrija.",
      expDateError: "Fecha de vencimiento no válida, corríjala.",
      verifyButton: "Verificar",
      confirmation: "Confirmación",
      selectPaymentMethod: "Seleccione el Método de Pago",
      selectPaymentAmount: "Seleccione el Monto del Pago",
      otherAmount: "Otra Cantidad",
      submitButton: "Entregar",
      confirmMessagePart1: "Ha seleccionado realizar un \n pago en: \n",
      confirmMessagePart2: "\n en la cantidad de: \n $ ",
      confirmAlert:
        "Actualizar la página durante el procesamiento puede causar errores en el saldo y pagos duplicados.",
      invoiceDownloading: "Descarga de facturas...",
      invoiceDownloaded: "Factura descargada",
      invoiceDownloadFailed: "No se pudo cargar la factura",
      noCCPaymentOption:
        "La opción de pago con tarjeta de crédito no está configurada para su ubicación.",
      noCCOnFile: "No hay tarjetas activas en el archivo.",
      ccDeleted: "Método de pago eliminado.",
      ccNotSupported: "Su ubicación actual no permite pagos con tarjeta de crédito en línea. Llámenos al (800) 634-3077.",
      paymentReceived: "Pago recibido.",
      paymentFailed: "Pago fallido.",
      ccVerificationError: "Hubo un problema al verificar esta forma de pago.",
      addAPaymentMethod:
        "Agregue un método de pago para realizar un pago en línea.",
      add: "Agregar",
      have2devices:
        "Actualmente tienes 2 dispositivos para este vehículo, uno debe devolverse para procesar un pago. ¿Necesita ayuda?",
      goBack: "Atrás",
      information: "Información",
      calibration: "Calibración",
      violationReset: "Restablecimiento de infracción",
      select: "Seleccionar",
      vehicle: "Vehículo",
      days: "Días",
      shippingAddress: "Dirección de envío",
      verify: "VERIFICAR",
      shipping: "Envío",
      standardShipping: "Envío estándar",
      expedientShipping: "Envío rápido",
      cancel: "Cancelar",
      paymentSummary: "Resumen de pago",
      makePaymentInPayment: "HACER EL PAGO",
      thankyouPayment: "Gracias por tu pago.",
      failurePayment: "Error en el pago, inténtelo de nuevo.",
      contactMessage: "Si el saldo total adeudado es inferior a $0, nuestra opción de pago en línea no está disponible. Para obtener ayuda con este pago, comuníquese con nuestro equipo de Atención al Cliente al (800) 634-3077.",
      earlyServiceFee:
        "Se aplicará un cargo por servicio anticipado de $10 a este pago.",
      appointmentDefinition: "Definición de cita",
      apptDescCalibration:
        "Cita de servicio estándar para que su dispositivo funcione de manera óptima.",
      apptDescLockOut1:
        "Si las luces de servicio y de bloqueo se encienden al mismo tiempo, estás en retiro anticipado y es necesario restablecer tu dispositivo.",
      apptDescLockOut2: "Nota: ",
      apptDescLockOut3:
        "Su dispositivo se bloqueará 5 días después de que estas luces comenzaran a parpadear.",
      quantity: "Cantidad",
      item: "Artículo",
      unitPrice: "Precio unitario",
      amount: "Cantidad",
      freeShips: "Gratis, se envía en 2-3 días hábiles",
      nextShips: [
        "$25,00. El dispositivo se ",
        "enviará",
        " el siguiente día hábil.",
      ],
      boxOverride: "Anulación de apartado postal",
      calculatingPayment: "Calculando el pago, NO actualice",
      processingPayment: "Procesando pago, NO actualice",
      taxableAmount: "Base imponible",
      tax: "Impuesto",
      nonTaxableAmount: "Monto no imponible",
      totalNewCharges: "Total de nuevos cargos",
      priorAccountBalance: "Saldo de cuenta anterior",
      totalAmountDueNow: "Monto total adeudado ahora",
      appointmentType: "Tipo de cita",
      due: "Adeudado",
      now: "Ahora",
    },
    documents: {
      ToDO: "Para Hacer",
      Completed: "Terminado",
      formHeader: "Formulario",
      infoHeader: "Información",
      actionHeader: "Acción",
      viewHeader: "Consultar",
      review: "Revisión",
      upload: "Subir",
      template: "Formulario",
      warning:
        "El botón Firmar y Enviar se activará cuando llegue a la última página del documento.",
      signAndSubmit: "Firmar y Enviar",
      signAndSubmitSM: "Firmar y\nEnviar",
      reviewed: "Revisado",
      warningNonSignature:
        "El botón Revisado se activará cuando llegue a la última página del documento.",
      signatureTitle: "Adopta tu firma",
      adoptSignature: "Adoptar Firma",
      cancel: "Cancelar",
      legalName: "Nombre y apellido legal",
      update: "Actualizar",
      agreementPartI:
        "Al seleccionar una firma y hacer clic en el botón 'Adoptar firma', acepta y firma el ",
      esa: "Acuerdo de Firma Electrónica.",
      agreementPartII:
        " Tómese el tiempo para leer este documento antes de continuar.",
      signature: "Firma",
      initials: "Iniciales",
      userSignatureSaveSuccess: "Firma de usuario guardada",
      saveCompletedReportSuccess: "Informe completo guardado",
      documentDownloading: "Descargando documento",
      documentDownloadFailed: "No se pudo descargar el documento",
      documentDownloadSuccess: "Documento descargado",
      documentUploadSuccess: "Documento subido",
      documentUploadFailed: "Error al cargar el documento",
      documentUploadDataError: "Archivo de datos incorrecto",
      documentUploadErrorUploadType: "Falta el tipo de carga",
      documentUploadErrorFileType: "Tipo de archivo no compatible",
      documentUploadErrorFileSize: "Tamaño máximo de archivo excedido",
      loadDocumentFailed: "No se pudo cargar el documento",
      instructions: "Instrucciones",
      photoInstructions:
        "Al tomar la fotografía, asegúrese de que el documento esté lo más centrado posible. Cuando esté listo, haga clic en el botón a continuación para activar su cámara, es posible que deba permitirnos este acceso (debería aparecer una ventana emergente).",
      computerCamInfo:
        "Nota: Es posible que muchas cámaras web integradas en computadoras portátiles no brinden una imagen de calidad suficiente para este proceso de carga.",
      fileInstructions:
        "Al tomar la fotografía, asegúrese de que el documento esté lo más centrado posible. Luego haga clic en el botón de carga y elija su imagen. Formatos aceptados: .png, .jpg, .jpeg, .heic, .pdf",
      retake: "Volver a tomar",
      photoUpload: "Tomar foto",
      fileUpload: "Subir documento",
      chooseFile: "Elija el archivo",
      newFile: "Elija otro archivo",
      goBack: "Atrás",
      badPhotoFile: "Archivo de foto incorrecto",
      uploadNow: "Cargar Ahora",
      documentExample: "Ejemplo",
      signDocumentFail: "Error al firmar el documento",
      save: "Guardar",
      saving: "Guardando",
      saved: "Guardado",
      saveError: "Error al guardar",
      formNotValid:
        "Por favor complete todos los campos requeridos del formulario.",
      invalidSSN:
        "Por favor ingrese un número de seguro social válido de 4 dígitos.",
      appointment: "Cita",
      declineModalHeader: "Información",
      declineModalBody:
        "La firma electrónica de documentos permite una instalación más rápida, lo que le ahorra tiempo. ¿Estás seguro de que no quieres firmar electrónicamente?",
      showHelpText: "¿Preguntas? Clic ",
      showHelpLinkText: "Aquí",
      signButton: "Firmar",
      declineButton: "Rechazar",
      noDocuments: "No hay documentos disponibles",
      form: "Formulario",
      vehicle: "Vehículo",
      viewExample:
        "El ejemplo se abrirá en una nueva pestaña momentáneamente. Es posible que deba permitir ventanas emergentes para este sitio.",
   
    bookingInstallation : "Gracias por agendar tu instalación. ¡Ahora hablemos de los siguientes pasos para tu éxito!",
      modalMessage1:" Recibirás un mensaje de texto de tu especialista White Glove de {{ brand }}, quien podrá hablar contigo sobre la instalación, descuentos disponibles y responder cualquier otra pregunta que tengas. Puedes enviarle mensajes de texto o llamarlo al número asignado especialmente para ti.",
      modalMessage2:"Al cerrar esta ventana, te redirigiremos a la sección de Documentos para que puedas revisar y firmar fácilmente tu papeleo previo a la instalación y proporcionar cualquier información requerida para cumplir con las regulaciones.",
      whiteGloveMessage:"Nuestro equipo White Glove está comprometido con tu éxito y te guiará durante todo el proceso previo a la instalación. Están listos para ayudarte, contáctalos ahora."

      },
    resources: {
      generalInfoHeader: "Información General",
      installCard: "Información de Instalación",
      installDesc:
        "Sepa qué esperar en su cita de instalación de interbloqueo.",
      installURL: "https://www.youtube.com/watch?v=dfMV64_RGx8",
      dosAndDontsCard: "Qué Hacer y Qué No Hacer Durante una Prueba",
      dosAndDontsDesc:
        "Comprenda lo que debe y no debe hacer al realizar una prueba de aliento con alcohol en su dispositivo.",
      dosAndDontsURL: "https://www.youtube.com/watch?v=fLVWcTyOi9A&t=10s",
      foodWarningCard: "Advertencia de Alimentos",
      foodWarningDesc:
        "Hay algunos alimentos que debe evitar antes de realizar una prueba, observe y aprenda cómo pueden afectarlo.",
      foodWarningURL: "https://www.youtube.com/watch?v=VZg9lDAMLfU",
      deviceInfoHeader: "Información del Dispositivo",
      L250TrainingCard: "L250 Entrenamiento",
      L250TrainingDesc:
        "Obtenga información sobre cómo usar y cuidar su dispositivo de bloqueo de encendido L250 con esta capacitación en video.",
      L250TrainingURL: "https://www.youtube.com/watch?v=bFeciu0DF4U&t=1s",
      L250WarmUpCard: "L250 Tiempos de Calentamiento",
      L250WarmUpDesc:
        "Aprenda a configurar los tiempos de calentamiento de su interbloqueo L250 para ahorrar tiempo en climas fríos.",
      L250WarmUpURL: "https://www.youtube.com/watch?v=mj4H6D5SYmw",
      FC100TrainingCard: "FC100 Entrenamiento",
      FC100TrainingDesc:
        "Obtenga información sobre cómo usar y cuidar su dispositivo de bloqueo de encendido FC100 con esta capacitación en video.",
      FC100TrainingURL: "https://www.youtube.com/watch?v=gZROvBInl_g",
      FI100TrainingCard: "FI100 Entrenamiento",
      FI100TrainingDesc:
        "Aprenda a usar y cuidar su dispositivo de bloqueo de encendido FI100 con este video de capacitación.",
      FI100TrainingURL: "https://www.youtube.com/watch?v=gZROvBInl_g",
      PAMTrainingCard: "PAM Entrenamiento",
      PAMTrainingDesc:
        "Aprenda a usar y cuidar su monitor portátil de alcohol con esta capacitación en video.",
      PAMTrainingURL: "https://www.youtube.com/watch?v=KVQUId66ZOs",
    },
    help: {
      contactUs: "Póngase en contacto con nosotros",
      contactUsMessage:
        ", ¡Brindemosle ayuda de nuestro equipo de soporte experto, disponible las 24 horas del día, los 7 días de la semana!",
      contactUsCallClick: "Llame o haga clic",
      emailUs: "Correo Electrónico",
      emailUsMessage: "¿Ha encontrado un problema o error en nuestro sitio?",
      chatTitle: "Ayuda",
      chatMessage:
        "¿Necesita ayuda con su cuenta y no puede encontrarla en el portal?",
      chatSubMessage: "Chatea con un agente.",
      chatButton: "Chatea ahora",
      callUsButton: "Llámanos ",
      lockout:
        "Esta cita no se puede reprogramar desde este portal, por favor contáctenos para que podamos ayudarlo con esta solicitud.",
    },
    securepay: {
      title: "Pago seguro",
      unauthorized: "No autorizado",
      securepayLinkdesc: [
        "El enlace de Secure Pay ha caducado o no está disponible. Si cree que ha llegado a este mensaje por error",
        "Siéntete libre de contactarnos.",
      ],
      sessionTimer: "Temporizador de sesión: ",
      client: "Cliente: ",
      amountDue: "Monto adeudado: ",
      makePayment: "HACER EL PAGO",
      agree: "Aceptar",
      paymentMethod: "Método de pago",
      payMessage:
        "Al enviar la información de su tarjeta de crédito o débito en esta página y marcar esta casilla, nos autoriza a cargar esta tarjeta de conformidad con la Política de términos de uso de LifeSafer.",
      paymentFailure: "Error en el pago, inténtelo de nuevo.",
      securePaymentSaveFailure: "Error al guardar el pago seguro:",
      errorWithCreditCard:
        "Error al guardar el pago con tarjeta de crédito, ID:",
      thankYou: "¡Gracias!",
      thankYouAfterPayment: [
        "El pago se ha procesado con éxito para ",
        "Recibirá un mensaje de texto con su recibo en breve; de ​​lo contrario, no dude en comunicarse con nosotros al (800) 634-3077",
      ],
      successPayment:
        "Pago realizado con éxito. En breve recibirás un mensaje de texto con el recibo.",
    },
  },
};
